module.exports = __webpack_public_path__ + "static/media/Cecilia_MartInez_Sandoval.ac4f14d3.jpg";